module.exports = __webpack_public_path__ + "static/media/lemon-juicing-hand.d2dd056f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2016-11-10/lemon-juicing-hand.jpg
// module id = 797
// module chunks = 0